import { titulosApi } from "../view/titulos.service";

export const uploadTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadTitulo: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/v1/api/titulo/${id}/upload/`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Titulos", id }, { type: "Titulos", id: "LIST" }],
    }),
  }),
});

export const { useUploadTituloMutation } = uploadTitulo;
